import React from 'react'
import SpinnerLoader from 'syf-component-library/ui/atoms/Loader/Spinner'
import Header from 'ui/atoms/Header'
import translate from 'helpers/translate'
import { LoadingWrapper, SpinnerWrapper } from './subcomponents'

const PersistLoading = () => {
  return (
    <LoadingWrapper>
      <SpinnerWrapper>
        <SpinnerLoader />
      </SpinnerWrapper>
      <Header
        data-test="loadingHeader"
        title={translate({ string: 'loggingIntoYourAccount' })}
      />
    </LoadingWrapper>
  )
}

export default PersistLoading
